<template>

  <div class="child" @click="$store.dispatch('navBuildingReport', reports.reportPK)">
    <header class="plate-header" style="width:100%;height:10%;">
      <div class="plate-header-img" style="width:20%;">
        <h4 style="color:white;width:100%;">Tustin</h4>
      </div>
      <div class="child-header-floor-info">
        <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/tilesWhite.png">
        <h4>{{reports[0].floorIndicies.length}} Floor{{reports[0].floorIndicies.length == 1 ? '' : 's'}}</h4>
      </div>
    </header>
    <div class="child-inner">
      <div class="child-stat" v-for="rdg in Object.keys(reports[0].alertRanges)">
        <div class="child-day rdg-day">
          <img :src="setRdgImg(rdg)">
        </div>
        <div v-for="(report, reportIndex) in reports" class="child-day" :style="{'background': setStatBG(report, rdg)}">
          <h3>{{showAbbrvDate(report)}}</h3>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import Donut from './Donut';

export default {
  data(){
    return {

    }
  },
  props: ['reports'],
  components: {donut: Donut},
  methods: {
    setRdgImg(rdg){
      const rdgRange = this.reports[0].alertRanges[rdg];
      const rdgIndex = Object.keys(this.reports[0].alertRanges).indexOf(rdg);
      const img = ['temp', 'hum', 'iaq', 'co2', 'nuevoVOC'][rdgIndex];
      return `https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${img}.png`;
    },
    setStatBG(report, rdg){
      const tiers = ['crit', 'bad', 'good'];
      const onlyRdg = report.alertRanges[rdg];
      const tier = tiers.find(t => onlyRdg[t]);
      return ['#ff002d', 'yellow', '#71C076'][tiers.indexOf(tier)];
    },
    showAbbrvDate(report){
      return new Date(report.tms*1000).toString().substring(0, 2)
    }
  }
}

</script>

<style>

.child {
  height: calc(100% - 40px);
  background: white;
  min-width: 350px;
  width: 30%;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0);
  border: 1px solid rgb(0, 153, 191);
  cursor: pointer;
}

.child:hover {
  border: 1px solid #dce1ec;
}

.child header {
  height: 15%;
}

.child-inner {
  width: 98%;
  height: 88%;
  padding: 1%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.child-stat {
  height: 17.5%;
  width: 98%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: .5%;
  background: #325468;
  border-bottom: 4px solid rgb(0, 153, 191);
}

.child-day {
  width: 37px;
  height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  overflow: hidden;
  border: 1px solid #dce1ec;
}

.rdg-day {
  background: rgb(0, 153, 191);
  width: 15%;
  height: 90%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  align-self: flex-end;
  border: none;
}

.rdg-day img {
  height: 60%;
}

.child-day h3 {
  font-weight: 700;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  font-size: .9em;
}

 .child-header-floor-info {
  width: 80%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}

.child-header-floor-info img {
  height: 40%;
  margin-right: 2px;
}

.child-header-floor-info h4 {
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/report/Child.vue